/* eslint-disable consistent-return */
/* eslint-disable no-loop-func */
/* eslint-disable no-alert */
/* eslint-disable max-depth */
/* eslint-disable complexity */
/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable max-params */
/* eslint-disable max-statements */
/* eslint-disable no-param-reassign */
import React from 'react';
import { formatDate } from './Common';
import constants from '../../constants';
const { timeZone, dateFormate, calendatSize, weekDaysList, monthList } = constants;

export function currentDateHandle(date) {
  var startDateByTimeZone = new Date(date).toLocaleString('en-US', { timeZone: timeZone });
  var dateObject = new Date(startDateByTimeZone);
  var YMDdate = dateObject.getFullYear();
  if (dateObject.getMonth() + 1 < 10) {
    YMDdate += '-' + '0' + (dateObject.getMonth() + 1).toString();
  } else {
    YMDdate += '-' + (dateObject.getMonth() + 1).toString();
  }
  if (dateObject.getDate() < 10) {
    YMDdate += '-' + '0' + dateObject.getDate().toString();
  } else {
    YMDdate += '-' + dateObject.getDate().toString();
  }
  return YMDdate;
}

export function onDayCalendarObject(startDate) {
  var oneDayObject = {};
  if (typeof oneDayObject[startDate] === 'undefined') {
    oneDayObject[startDate] = {};
  }

  oneDayObject[startDate]['date'] = startDate;
  var dateObj = new Date(startDate);
  var firstDay = dateObj.getDate().toString();
  if (firstDay <= 9) {
    firstDay = ('0' + firstDay).toString();
  }
  oneDayObject[startDate]['day'] = firstDay;
  oneDayObject[startDate]['dayName'] = weekDaysList[dateObj.getDay()];
  oneDayObject[startDate]['monthName'] = monthList[dateObj.getMonth()];
  return oneDayObject;
}

export function calenderDateUIHandler(startDate, noOfDays) {
  noOfDays -= 1;
  var dateListArr = {};
  var startDateFormate = formatDate(startDate, dateFormate, 'yyyy-mm-dd');
  var startDateByTimeZone = new Date(startDateFormate).toLocaleString('en-US', { timeZone: timeZone });
  var dateObj = new Date(startDateByTimeZone);
  dateListArr = onDayCalendarObject(startDateFormate);

  for (var i = 1; i <= parseInt(noOfDays); i++) {
    dateObj.setDate(dateObj.getDate() + 1);
    var month = dateObj.getMonth();
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();
    var dayNameIntVal = dateObj.getDay();
    month += 1;
    var formatedMonth = month;
    if (parseInt(month) < 10) {
      formatedMonth = '0' + month;
    }
    if (parseInt(day) < 10) {
      day = '0' + day;
    }
    var finalDate = year + '-' + formatedMonth + '-' + day;
    if (typeof dateListArr[finalDate] === 'undefined') {
      dateListArr[finalDate] = {};
    }
    dateListArr[finalDate]['date'] = finalDate;
    dateListArr[finalDate]['day'] = day.toString();
    dateListArr[finalDate]['dayName'] = weekDaysList[dayNameIntVal];
    dateListArr[finalDate]['monthName'] = monthList[month - 1];
  }
  return dateListArr;
}

export function swapCategoryData(others, otaData, backup, userId, callBack) {
  otaData = {};
  let response = {};
  if (userId === 0) {
    let otaIds = Object.keys(backup.rateassociatedwithuser);
    if (otaIds.length === 0) {
      let categoryData = { ...backup.categorymaster };
      let categoryIds = Object.keys(categoryData);
      for (var c = 0; c < categoryIds.length; c++) {
        let categoryId = categoryIds[c];
        categoryData[categoryId]['rateplans'] = {};
        if (typeof otaData[userId] === 'undefined') {
          otaData[userId] = {};
        }
        if (typeof otaData[userId]['category'] === 'undefined') {
          otaData[userId]['category'] = {};
        }
        Object.keys(categoryData[categoryId].rateplans).map(rateplanId => {
          if (typeof otaData[userId]['category'][categoryId + '_' + rateplanId] === 'undefined') {
            otaData[userId]['category'][categoryId + '_' + rateplanId] = {};
          }
          otaData[userId]['category'][categoryId + '_' + rateplanId] = categoryData[categoryId];
        });
      }
    } else {
      for (var i = 0; i < otaIds.length; i++) {
        let otaId = otaIds[i];
        let categoryData = { ...backup.rateassociatedwithuser[otaId]['category'] };
        let categoryIds = Object.keys(categoryData);
        for (c = 0; c < categoryIds.length; c++) {
          let categoryId = categoryIds[c];
          categoryData[categoryId]['rateplans'] = {};
          if (typeof otaData[userId] === 'undefined') {
            otaData[userId] = {};
          }
          if (typeof otaData[userId]['category'] === 'undefined') {
            otaData[userId]['category'] = {};
          }
          Object.keys(categoryData[categoryId].rateplans).map(rateplanId => {
            if (typeof otaData[userId]['category'][categoryId + '_' + rateplanId] === 'undefined') {
              otaData[userId]['category'][categoryId + '_' + rateplanId] = {};
            }
            otaData[userId]['category'][categoryId + '_' + rateplanId] = categoryData[categoryId];
          });
        }
      }
    }
  } else {
    let categoryData = { ...rateassociatedwithuser[userId]['category'] };
    let categoryIds = Object.keys(categoryData);
    for (c = 0; c < categoryIds.length; c++) {
      let categoryId = categoryIds[c];
      categoryData[categoryId]['rateplans'] = {};
      if (typeof otaData[userId] === 'undefined') {
        otaData[userId] = {};
      }
      if (typeof otaData[userId]['category'] === 'undefined') {
        otaData[userId]['category'] = {};
      }
      if (
        typeof otaData[userId]['category'][categoryId + '_' + categoryData[categoryId]['mapping_id']] === 'undefined'
      ) {
        otaData[userId]['category'][categoryId + '_' + categoryData[categoryId]['mapping_id']] = {};
      }
      otaData[userId]['category'][categoryId + '_' + categoryData[categoryId]['mapping_id']] =
        categoryData[categoryId];
    }
  }
  response['others'] = others;
  response['otaData'] = otaData;
  callBack(response);
}

export function filterEventHandler(identifier, date, userId, index, endDate, categoryId) {
  let response = {};
  response.datelist = {};
  if (identifier === 'datechange') {
    response.datelist = {};
    response.datelist = calenderDateUIHandler(date, calendatSize);
  }
  return response;
}

export function setPrevious10DayFlag(others, startDate, calendatSize) {
  calendatSize -= 2;
  others.isPreviousDayShow = 0;
  var calendarDate = new Date(startDate);
  var todayDate = new Date();
  todayDate.setDate(todayDate.getDate() + calendatSize);
  if (calendarDate >= todayDate) {
    others.isPreviousDayShow = 1;
  }
  return others;
}

export function inventoryCellUIHandler(
  others,
  userId,
  categoryId,
  date,
  identifier,
  ischecked,
  commonData,
  dateList,
  backup,
  categoryWithMapping,
  localAvailCount,
  callBack
) {
  let inventorySelectedSection = others['inventorySelectedSection'];
  let horizontalInventoryRowChecked = others['horizontalInventoryRowChecked'];
  let response = {};
  response['InventoryEventHandlingData'] = commonData['InventoryEventHandlingData'];
  response['startStopSaleEventHandlingData'] = commonData['startStopSaleEventHandlingData'];
  inventorySelectedSection = defineInventorySelectedSection(inventorySelectedSection, userId, categoryId, date);
  if (
    isDeselect(horizontalInventoryRowChecked, userId, categoryId, ischecked) &&
    typeof inventorySelectedSection[userId][categoryId][date]['isSelected'] !== 'undefined' &&
    inventorySelectedSection[userId][categoryId][date]['isSelected'] === 1
  ) {
    inventorySelectedSection[userId][categoryId][date]['isSelected'] = 0;
    let result = removeInventoryUIAndEventData(userId, categoryId, date, identifier, commonData);
    response['InventoryEventHandlingData'] = result['InventoryEventHandlingData'];
    response['startStopSaleEventHandlingData'] = result['startStopSaleEventHandlingData'];
  } else {
    let result = prepareInventoryUIAndEventData(
      inventorySelectedSection,
      userId,
      categoryWithMapping,
      date,
      identifier,
      localAvailCount,
      commonData,
      backup
    );
    inventorySelectedSection = result['inventorySelectedSection'];
    response['InventoryEventHandlingData'] = result['InventoryEventHandlingData'];
    response['startStopSaleEventHandlingData'] = result['startStopSaleEventHandlingData'];
  }
  response['calendarSelectedDate'] = isVerticalSelection(commonData.otaData, others, userId, date, categoryId);
  if (typeof ischecked === 'undefined' || ischecked !== 'ischecked') {
    response['horizontalInventoryRowChecked'] = isHorizontalSection(dateList, others, userId, categoryId);
  }
  response['showHideButton'] = enableAndDisableButtons(
    userId,
    categoryId,
    date,
    commonData,
    others,
    categoryWithMapping
  );
  response['inventorySelectedSection'] = inventorySelectedSection;
  response['horizontalInventoryRowChecked'] = horizontalInventoryRowChecked;

  callBack(response);
}

export function isVerticalSelection(otaData, others, userId, date, catId) {
  var flag = 1;
  var calendarSelectedDate = others.calendarSelectedDate;
  var categoryIds = Object.keys(otaData);
  for (var i = 0; i < categoryIds.length; i++) {
    var categoryId = categoryIds[i];
    if (typeof others.inventorySelectedSection[userId][categoryId] === 'undefined') {
      flag = 0;
    } else if (typeof others.inventorySelectedSection[userId][categoryId][date] === 'undefined') {
      flag = 0;
    } else if (others.inventorySelectedSection[userId][categoryId][date]['isSelected'] === 0) {
      flag = 0;
    }
  }
  if (flag === 1) {
    calendarSelectedDate[date] = date;
  } else {
    if (typeof calendarSelectedDate[date] !== 'undefined') {
      delete calendarSelectedDate[date];
    }
  }
  return calendarSelectedDate;
}

export function isHorizontalSection(dateList, others, userId, categoryId) {
  var horizontalInventoryRowChecked = others.horizontalInventoryRowChecked;
  var flag = 1;
  var dateListArr = Object.keys(dateList);
  for (var i = 0; i < dateListArr.length; i++) {
    var dateKey = dateListArr[i];
    if (typeof others.inventorySelectedSection[userId][categoryId] === 'undefined') {
      flag = 0;
    } else if (typeof others.inventorySelectedSection[userId][categoryId][dateKey] === 'undefined') {
      flag = 0;
    } else if (others.inventorySelectedSection[userId][categoryId][dateKey]['isSelected'] === 0) {
      flag = 0;
    }
  }
  if (flag === 1) {
    if (typeof horizontalInventoryRowChecked[userId] === 'undefined') {
      horizontalInventoryRowChecked[userId] = {};
    }
    if (typeof horizontalInventoryRowChecked[userId][categoryId] === 'undefined') {
      horizontalInventoryRowChecked[userId][categoryId] = {};
    }
    horizontalInventoryRowChecked[userId][categoryId]['is_checked'] = 1;
  } else {
    if (horizontalInventoryRowChecked[userId]) {
      if (horizontalInventoryRowChecked[userId][categoryId]) {
        horizontalInventoryRowChecked[userId][categoryId]['is_checked'] = 0;
      }
    }
  }
  return horizontalInventoryRowChecked;
}

export function enableAndDisableButtons(userId, categoryId, date, commonData, others, categoryWithMapping) {
  let showHideButton = others['showHideButton'];
  if (commonData.InventoryEventHandlingData.length > 0) {
    showHideButton.allocation = 1;
    showHideButton.stopSale = 1;
    if (userId === 0) {
      showHideButton.block = 1;
      showHideButton.unBlock = 1;
      showHideButton.stopSale = 1;
    }
  } else {
    showHideButton.block = 0;
    showHideButton.unBlock = 0;
    showHideButton.stopSale = 0;
    showHideButton.allocation = 0;
  }
  if (commonData.startStopSaleEventHandlingData.length > 0) {
    if (isStartSaleEnable(userId, categoryId, date, commonData, others, categoryWithMapping)) {
      showHideButton.startSale = 1;
    }
  } else {
    showHideButton.startSale = 0;
  }
  showHideButton.updateRate = 0;
  if (commonData.eventHandlingData.length > 0) {
    showHideButton.updateRate = 1;
  }
  return showHideButton;
}

export function removeInventoryUIAndEventData(userId, categoryId, date, identifier, commonData) {
  let response = {};
  response['InventoryEventHandlingData'] = commonData.InventoryEventHandlingData;
  response['startStopSaleEventHandlingData'] = commonData.startStopSaleEventHandlingData;
  if (identifier === 'stopsale') {
    response['InventoryEventHandlingData'] = deleteDataFromInventoryEventHandlingData(
      userId,
      categoryId,
      date,
      commonData.InventoryEventHandlingData
    );
  } else if (identifier === 'startsale') {
    response['startStopSaleEventHandlingData'] = deleteDataFromStartStopSaleEventHandlingData(
      userId,
      categoryId,
      date,
      commonData.startStopSaleEventHandlingData
    );
  } else if (identifier === 'both') {
    response['InventoryEventHandlingData'] = deleteDataFromInventoryEventHandlingData(
      userId,
      categoryId,
      date,
      commonData.InventoryEventHandlingData
    );
    response['startStopSaleEventHandlingData'] = deleteDataFromStartStopSaleEventHandlingData(
      userId,
      categoryId,
      date,
      commonData.startStopSaleEventHandlingData
    );
  }
  return response;
}

export function deleteDataFromInventoryEventHandlingData(userId, categoryId, date, InventoryEventHandlingData) {
  var findMe = { date: date, category_id: categoryId, user_id: userId };
  var index = InventoryEventHandlingData.findIndex(row => {
    if (row.date === findMe.date && row.category_id === findMe.category_id && row.userId === findMe.userId) {
      return true;
    } else {
      return false;
    }
  });
  InventoryEventHandlingData.splice(index, 1);
  return InventoryEventHandlingData;
}

export function deleteDataFromStartStopSaleEventHandlingData(userId, categoryId, date, startStopSaleEventHandlingData) {
  var findMe = { date: date, category_id: categoryId, user_id: userId };
  var index = startStopSaleEventHandlingData.findIndex(row => {
    if (
      row.date === findMe.date &&
      row.category_id === findMe.category_id &&
      row.ratePlanId === findMe.ratePlanId &&
      row.userId === findMe.userId
    ) {
      return true;
    } else {
      return false;
    }
  });
  startStopSaleEventHandlingData.splice(index, 1);
  return startStopSaleEventHandlingData;
}

export function isStartSaleEnable(userId, categoryId, date, commonData, others, categoryWithMapping) {
  var flag = 0;
  let calendarSelectedDate = others['calendarSelectedDate'];
  if (userId.toString() !== '' && categoryWithMapping !== '' && date !== '') {
    if (typeof commonData.otaData[userId]['category'][categoryWithMapping] !== 'undefined') {
      if (typeof commonData.otaData[userId]['category'][categoryWithMapping]['inventory'] !== 'undefined') {
        if (typeof commonData.otaData[userId]['category'][categoryWithMapping]['inventory'][date] !== 'undefined') {
          if (
            typeof commonData.otaData[userId]['category'][categoryWithMapping]['inventory'][date]['stopSell'] !==
            'undefined'
          ) {
            if (commonData.otaData[userId]['category'][categoryWithMapping]['inventory'][date]['stopSell'] === 1) {
              flag = 1;
            }
          }
        }
      }
    } else if (date !== '') {
      let categoryIds = Object.keys(commonData.otaData[userId]['category']);
      for (var i = 0; i < categoryIds.length; i++) {
        categoryId = categoryIds[i];
        if (typeof commonData.otaData[userId]['category'][categoryWithMapping] !== 'undefined') {
          if (typeof commonData.otaData[userId]['category'][categoryWithMapping]['inventory'] !== 'undefined') {
            if (typeof commonData.otaData[userId]['category'][categoryWithMapping]['inventory'][date] !== 'undefined') {
              if (
                typeof commonData.otaData[userId]['category'][categoryWithMapping]['inventory'][date]['stopSell'] !==
                'undefined'
              ) {
                if (commonData.otaData[userId]['category'][categoryWithMapping]['inventory'][date]['stopSell'] === 1) {
                  if (typeof calendarSelectedDate[date] !== 'undefined') {
                    if (calendarSelectedDate[date] === date) {
                      flag++;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return flag;
  }
}

export function isDeselect(horizontalInventoryRowChecked, userId, categoryId, ischecked) {
  if (typeof horizontalInventoryRowChecked[userId] !== 'undefined') {
    if (typeof horizontalInventoryRowChecked[userId][categoryId] !== 'undefined') {
      if (typeof horizontalInventoryRowChecked[userId][categoryId]['is_checked'] !== 'undefined') {
        if (
          typeof ischecked !== 'undefined' &&
          ischecked === 'ischecked' &&
          horizontalInventoryRowChecked[userId][categoryId]['is_checked'] === 1
        ) {
          return false;
        }
      }
    }
  }
  return true;
}

export function startStopOrBoth(commonData, others, userId, date) {
  var startStopSale = 'both';
  if (
    Object.keys(commonData.otaData[userId]['category']).length ===
    isStartSaleEnable(userId, '', date, commonData, others)
  ) {
    startStopSale = 'startsale';
  } else if (isStartSaleEnable(userId, '', date, commonData, others) === 0) {
    startStopSale = 'stopsale';
  }
  return startStopSale;
}

export function selectAllInventoryOfDate(others, commonData, inventorySelectedSection, userId, date, backup, callBack) {
  let response = {};
  let calendarSelectedDate = others['calendarSelectedDate'];
  let result = {};
  var startStopSale = startStopOrBoth(commonData, others, userId, date);
  if (typeof calendarSelectedDate[date] !== 'undefined') {
    delete calendarSelectedDate[date];

    result = selectInventoryOfAllCategory(
      commonData,
      inventorySelectedSection,
      userId,
      date,
      'remove',
      startStopSale,
      backup
    );
  } else {
    calendarSelectedDate[date] = date;
    startStopSale = startStopOrBoth(commonData, others, userId, date);
    result = selectInventoryOfAllCategory(
      commonData,
      inventorySelectedSection,
      userId,
      date,
      'add',
      startStopSale,
      backup
    );
  }
  response['showHideButton'] = enableAndDisableButtons(userId, 0, date, commonData, others);
  // $scope.enableAndDisableButtons($scope.filter.userId, '', date, startStopSale);
  response['calendarSelectedDate'] = calendarSelectedDate;
  response['inventorySelectedSection'] = result['inventorySelectedSection'];
  response['InventoryEventHandlingData'] = result['InventoryEventHandlingData'];
  callBack(response);
}

export function selectInventoryOfAllCategory(commonData, inventorySelectedSection, userId, date, identifier, startStopSale, backup) {
  let response = {};
  let otaData = commonData.otaData[userId]['category'];
  let result = {};
  let useableCategoryArr = Object.keys(otaData);
  for (let i = 0; i < useableCategoryArr.length; i++) {
    let categoryId = useableCategoryArr[i];
    if (identifier === 'add') {
      inventorySelectedSection = defineInventorySelectedSection(
        inventorySelectedSection,
        userId,
        categoryId,
        date
      );
      result = prepareInventoryUIAndEventData(
        inventorySelectedSection,
        userId,
        categoryId,
        date,
        startStopSale,
        commonData,
        backup
      );
    } else {
      result = removeSelectedInventory(
        inventorySelectedSection,
        userId,
        date,
        categoryId,
        startStopSale,
        commonData
      );
    }
  }
  response['inventorySelectedSection'] = result['inventorySelectedSection'];
  response['InventoryEventHandlingData'] = result['InventoryEventHandlingData'];
  return response;
}

export function removeSelectedInventory(inventorySelectedSection, userId, date, categoryId, startStopSale, commonData) {
  let response = {};

  delete inventorySelectedSection[userId][categoryId][date];
  response['inventorySelectedSection'] = inventorySelectedSection;
  var removeData = [];
  let inventoryEventHandlingData = commonData['InventoryEventHandlingData'];
  for (let i = 0; i < inventoryEventHandlingData.length; i++) {
    if (typeof inventoryEventHandlingData[i] !== 'undefined') {
      if (inventoryEventHandlingData[i]['date'] === date) {
        removeData.push(i);
      }
    }
  }

  removeData.forEach((item, index) => {
    if (inventoryEventHandlingData[item]['date'] === date) {
      delete inventoryEventHandlingData[item];
    }
  });
  inventoryEventHandlingData = inventoryEventHandlingData.filter(x => {
    return x !== null;
  });

  response['inventorySelectedSection'] = inventorySelectedSection;
  response['InventoryEventHandlingData'] = inventoryEventHandlingData;

  return response;
}

export function prepareInventoryUIAndEventData(
  inventorySelectedSection,
  userId,
  categoryWithMapping,
  date,
  identifier,
  localAvailCount,
  commonData,
  backup
) {
  let catMappingArr = categoryWithMapping.split('_');
  let categoryId = catMappingArr[0];
  let response = {};
  let InventoryEventHandlingData = commonData['InventoryEventHandlingData'];
  let startStopSaleEventHandlingData = commonData['startStopSaleEventHandlingData'];
  let room_category_id = backup['categorymaster'][categoryId]['room_category_id'];
  if (typeof inventorySelectedSection[userId] !== 'undefined') {
    if (typeof inventorySelectedSection[userId][categoryId] !== 'undefined') {
      if (typeof inventorySelectedSection[userId][categoryId][date] !== 'undefined') {
        inventorySelectedSection[userId][categoryId][date]['isSelected'] = 1;
      }
    }
  }
  if (identifier === 'both') {
    InventoryEventHandlingData.push({
      date: date,
      category_id: categoryId,
      user_id: userId,
      room_category_id: room_category_id,
      number_of_rooms: localAvailCount,
      category_with_mapping: categoryWithMapping
    });
    startStopSaleEventHandlingData.push({
      date: date,
      category_id: categoryId,
      user_id: userId,
      room_category_id: room_category_id,
      number_of_rooms: localAvailCount,
      category_with_mapping: categoryWithMapping
    });
  } else if (identifier === 'stopsale') {
    InventoryEventHandlingData.push({
      date: date,
      category_id: categoryId,
      user_id: userId,
      room_category_id: room_category_id,
      number_of_rooms: localAvailCount,
      category_with_mapping: categoryWithMapping
    });
  } else if (identifier === 'block') {
    InventoryEventHandlingData.push({
      date: date,
      category_id: categoryId,
      user_id: userId,
      room_category_id: room_category_id,
      number_of_rooms: localAvailCount,
      category_with_mapping: categoryWithMapping
    });
  } else {
    startStopSaleEventHandlingData.push({
      date: date,
      category_id: categoryId,
      user_id: userId,
      room_category_id: room_category_id,
      number_of_rooms: localAvailCount,
      category_with_mapping: categoryWithMapping
    });
  }
  response['inventorySelectedSection'] = inventorySelectedSection;
  response['InventoryEventHandlingData'] = InventoryEventHandlingData;
  response['startStopSaleEventHandlingData'] = startStopSaleEventHandlingData;

  return response;
}

export function defineInventorySelectedSection(inventorySelectedSection, userId, categoryId, date) {
  if (typeof inventorySelectedSection[userId] === 'undefined') {
    inventorySelectedSection[userId] = {};
  }
  if (typeof inventorySelectedSection[userId][categoryId] === 'undefined') {
    inventorySelectedSection[userId][categoryId] = {};
  }
  if (typeof inventorySelectedSection[userId][categoryId][date] === 'undefined') {
    inventorySelectedSection[userId][categoryId][date] = {};
  }
  return inventorySelectedSection;
}

export function expandCollapseCategorySection(
  categorySectionExpand,
  rateplanSectionExpand,
  ratepresentInOccupancyByCategory,
  backup,
  otaData,
  userId,
  categoryWithMapping,
  rateplanId,
  callBack
) {

  let catMapArr = categoryWithMapping.split('_');
  let categoryId = catMapArr[0];
  let response = {};
  let result = {};
  let rateInventoryBackup = JSON.parse(JSON.stringify(backup.rateInventory));
  if (typeof categoryId !== 'undefined' && categoryId > 0 && typeof rateplanId !== 'undefined' && rateplanId > 0) {
    result = ratePlanExpandCollapseHandler(rateplanSectionExpand, categoryWithMapping, rateplanId);
    result['categorySectionExpand'] = categorySectionExpand;
    ratepresentInOccupancyByCategory = pushOccupancyHavingRate(
      ratepresentInOccupancyByCategory,
      otaData,
      userId,
      categoryId,
      rateplanId
    );
    otaData = pushRateinOtaData(rateInventoryBackup, otaData, userId, categoryWithMapping, rateplanId);
    /*pushRateinOtaData(rateInventoryBackup,otaData,userId,categoryId, rateplanId,(result)=>{
      otaData = result;
    });*/
  } else {
    result = categoryExpandHandler(categorySectionExpand, rateplanSectionExpand, categoryId);
    otaData = appendOccupancyCategoryList(otaData, backup, categoryId, userId, categoryWithMapping);
  }
  response['rateplanSectionExpand'] = result['rateplanSectionExpand'];
  response['ratepresentInOccupancyByCategory'] = ratepresentInOccupancyByCategory;
  response['otaData'] = otaData;
  response['categorySectionExpand'] = result['categorySectionExpand'];

  callBack(response);
}

export function appendOccupancyCategoryList(otaData, backup, categoryId, userId, categoryWithMapping) {
  let rateassociatedwithuserBackup = backup.rateassociatedwithuser;
  let inventory = backup.rateInventory;
  let otaIds = Object.keys(rateassociatedwithuserBackup);
  /*** we put if else :- because if there is not any chanel connected or OTA is not connected with any rate plan  */
  if (
    otaIds.length > 0 &&
    typeof rateassociatedwithuserBackup[otaIds[0]]['category'][categoryId] !== 'undefined' &&
    typeof rateassociatedwithuserBackup[otaIds[0]]['category'][categoryId]['rateplans'] !== 'undefined'
  ) {
    for (i = 0; i < otaIds.length; i++) {
      let otaId = otaIds[i];
      if (typeof otaData[userId]['category'][categoryId] === 'undefined') {
        let rateplanData = backup.categoryrateplanmapping[categoryWithMapping];
        otaData[userId]['category'][categoryWithMapping]['rateplans'] = rateplanData['ratePlans'];
      } else {
        if (Object.keys(otaData[userId]['category'][categoryId]['rateplans']).length === 0) {
          otaData[userId]['category'][categoryId]['rateplans'] = JSON.parse(
            JSON.stringify(rateassociatedwithuserBackup[otaId]['category'][categoryId]['rateplans'])
          );
        } else if (typeof otaData[userId]['category'][categoryId]['rateplans'] === 'undefined') {
          otaData[userId]['category'][categoryId]['rateplans'] = {};
        }
      }
    }
  } else {
    let rateplanData = backup.categoryrateplanmapping[categoryWithMapping];
    otaData[userId]['category'][categoryWithMapping]['rateplans'] = rateplanData['ratePlans'];

  }
  if (typeof otaData[userId]['category'][categoryWithMapping]['rateplans'] !== 'undefined') {
    let ratePlanIds = Object.keys(otaData[userId]['category'][categoryWithMapping]['rateplans']);
    for (var i = 0; i < ratePlanIds.length; i++) {
      let ratePlanId = ratePlanIds[i];
      otaData[userId]['category'][categoryWithMapping]['rateplans'][ratePlanId]['minmaxlos'] =
        inventory[categoryWithMapping]['rates'][ratePlanId][userId]['inventory'];
    }
  }

  /** NOTE :--  Array rateinventoryData different structure,
   * when userid having 0 then append all rate plan,
   * when userId > 0 then append rateplan having Rate */
  /*  if (typeof otaData[categoryId]) {
    usableCategory[categoryId]['inventory'] = {};
     // if(userId==0){
      let ratePlanIds = Object.keys(rateinventoryData);
      for(var i=0;i<ratePlanIds.length;i++){
        usableCategory[categoryId]['rateplan']={};
        usableCategory[categoryId]['rateplan']['rates']={};
        usableCategory[categoryId]['rateplan']['rates'][ratePlanIds[i]]={};
        usableCategory[categoryId]['rateplan']['rates'][ratePlanIds[i]]['ratelist']={};
        usableCategory[categoryId]['rateplan']['rates'][ratePlanIds[i]]['inventory']={};
      }

    /*  }else{
      usableCategory[categoryId]['inventory'] = rateinventoryData[categoryId]['inventory'][userId];
      usableCategory[categoryId]['rateplan'] = rateinventoryData[categoryId];
    }*/
  /*}*/

  return otaData;
}

export function pushRateinOtaData(rateInventoryBackup, otaData, userId, categoryId, rateplanId) {
  if (typeof rateInventoryBackup[categoryId] !== 'undefined') {
    if (typeof rateInventoryBackup[categoryId]['rates'] !== 'undefined') {
      if (typeof rateInventoryBackup[categoryId]['rates'][rateplanId] !== 'undefined') {
        if (typeof rateInventoryBackup[categoryId]['rates'][rateplanId][userId] !== 'undefined') {
          if (typeof rateInventoryBackup[categoryId]['rates'][rateplanId][userId]['ratelist'] !== 'undefined') {
            let rateDateLabel = Object.keys(rateInventoryBackup[categoryId]['rates'][rateplanId][userId]['ratelist']);

            for (var i = 0; i < rateDateLabel.length; i++) {
              let date = rateDateLabel[i];
              let dateLavelData =
                rateInventoryBackup[categoryId]['rates'][rateplanId][userId]['ratelist'][rateDateLabel[i]];
              let occupancyIds = Object.keys(dateLavelData['occupancy']);

              for (var j = 0; j < occupancyIds.length; j++) {
                let occupancyId = occupancyIds[j];
                let occupancyLavelData = dateLavelData['occupancy'][occupancyId];

                if (
                  typeof otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates'] === 'undefined'
                ) {
                  otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates'] = {};
                }
                if (
                  typeof otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates']['occupancy'] ===
                  'undefined'
                ) {
                  otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates']['occupancy'] = {};
                }
                if (
                  typeof otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates']['occupancy'][
                    occupancyId
                  ] === 'undefined'
                ) {
                  otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates']['occupancy'][
                    occupancyId
                  ] = {};
                }
                if (
                  typeof otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates']['occupancy'][
                    occupancyId
                  ][date] === 'undefined'
                ) {
                  otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates']['occupancy'][occupancyId][
                    date
                  ] = {};
                }

                otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates']['occupancy'][occupancyId][
                  date
                ]['aop'] = occupancyLavelData['aop'];
                
                otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates']['occupancy'][occupancyId][
                  date
                ]['aop_without_tax'] = occupancyLavelData['aop_without_tax'];
                otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates']['occupancy'][occupancyId][
                  date
                ]['aop_and_tax'] = occupancyLavelData['aop_and_tax'];
              }

              // if (typeof dateLavelData['kidextrabed'] !== 'undefined') {
              //   if (
              //     typeof otaData[userId]['category'][categoryId]['rateplans'][ratePlanId]['rates']['kidextrabed'] ===
              //     'undefined'
              //   ) {
              //     otaData[userId]['category'][categoryId]['rateplans'][ratePlanId]['rates']['kidextrabed'] = {};
              //   }
              //   otaData[userId]['category'][categoryId]['rateplans'][ratePlanId]['rates']['kidextrabed'][date] =
              //     dateLavelData['kidextrabed'];
              // }

            }
          }
        }
      }
    }
  }
  return otaData;
}

export function pushOccupancyHavingRate(ratepresentInOccupancyByCategory) {
  return ratepresentInOccupancyByCategory;
}

export function ratePlanExpandCollapseHandler(rateplanSectionExpand, categoryId, rateplanId) {
  let response = {};
  rateplanSectionExpand = {};
  if (typeof rateplanSectionExpand[categoryId] !== 'undefined') {
    if (typeof rateplanSectionExpand[categoryId][rateplanId] !== 'undefined') {
      delete rateplanSectionExpand[categoryId][rateplanId];
    } else {
      if (typeof rateplanSectionExpand[categoryId] === 'undefined') {
        rateplanSectionExpand[categoryId] = {};
      }
      rateplanSectionExpand[categoryId][rateplanId] = rateplanId;
    }
  } else {
    if (typeof rateplanSectionExpand[categoryId] === 'undefined') {
      rateplanSectionExpand[categoryId] = {};
    }
    rateplanSectionExpand[categoryId][rateplanId] = rateplanId;
  }
  response['rateplanSectionExpand']  = {};
  response['rateplanSectionExpand'] = rateplanSectionExpand;
  return response;
}

export function categoryExpandHandler(categorySectionExpand, rateplanSectionExpand, categoryId) {
  let response = {};
  if (typeof categorySectionExpand[categoryId] !== 'undefined') {
    delete categorySectionExpand[categoryId];
    if (typeof rateplanSectionExpand[categoryId] !== 'undefined') {
      delete rateplanSectionExpand[categoryId];
    }
  } else {
    categorySectionExpand[categoryId] = {};
    categorySectionExpand[categoryId] = categoryId;
  }
  response['categorySectionExpand'] = categorySectionExpand;
  response['rateplanSectionExpand'] = {};
  return response;
}

export function pushInventoryData(others, otaData, inventoryData, categoryMaster, userId, backup, callBack) {
  let response = {};
  let rateInventory = inventoryData['rateinventorylist'];
  let categoryIds = Object.keys(rateInventory);
  
  for (var i = 0; i < categoryIds.length; i++) {
    let categoryWithMapping = categoryIds[i];
    let catMappintArr = categoryWithMapping.split('_');
    let categoryId = catMappintArr[0];
    let rateDetails = rateInventory[categoryWithMapping]['rates'];
    let ratePlanIds = Object.keys(rateDetails);
    
    for (var r = 0; r < ratePlanIds.length; r++) {
      let ratePlanId = ratePlanIds[r];
      let rateData = rateDetails[ratePlanId];
      let otaIds = Object.keys(rateData);
      
      for (var e = 0; e < otaIds.length; e++) {
        let rateListByDate = rateData[otaIds[e]]['ratelist'];
        let dates = Object.keys(rateListByDate);
        
        for (var d = 0; d < dates.length; d++) {
          let date = dates[d];
          let occupanyRate = rateListByDate[date]['occupancy'];
          let occupancyIds = Object.keys(occupanyRate);
          
          for (var o = 0; o < occupancyIds.length; o++) {
            if (typeof otaData[userId] === 'undefined') {
              otaData[userId] = {};
            }

            if (typeof otaData[userId]['category'] === 'undefined') {
              otaData[userId]['category'] = {};
            }
            
            if (typeof otaData[userId]['category'][categoryWithMapping] === 'undefined') {
              otaData[userId]['category'][categoryWithMapping] = {};
            }
            
            otaData[userId]['category'][categoryWithMapping] = categoryMaster[categoryId];
            otaData[userId]['category'][categoryWithMapping]['channel_room_type_name'] = '';
            otaData[userId]['category'][categoryWithMapping]['channel_rate_plan_name'] = '';

            if (
              typeof backup['rateassociatedwithuser'][userId] !== 'undefined' &&
              typeof backup['rateassociatedwithuser'][userId]['category'] !== 'undefined' &&
              typeof backup['rateassociatedwithuser'][userId]['category'][categoryId] !== 'undefined'
            ) {
              otaData[userId]['category'][categoryWithMapping]['channel_room_type_name'] =
                backup['rateassociatedwithuser'][userId]['category'][categoryId]['channel_room_type_name'];
              otaData[userId]['category'][categoryWithMapping]['channel_rate_plan_name'] =
                backup['rateassociatedwithuser'][userId]['category'][categoryId]['channel_rate_plan_name'];
            }

            if (typeof otaData[userId]['category'][categoryWithMapping]['inventory'] === 'undefined') {
              otaData[userId]['category'][categoryWithMapping]['inventory'] = {};
            }
            otaData[userId]['category'][categoryWithMapping]['inventory'] =
              rateInventory[categoryWithMapping]['inventory'][userId];
          }
        }
      }
    }

    // Append First category rateplan and their rates
    if (Object.keys(otaData[userId]['category']).length > 0) {
      let firstCategoryWithMapping = Object.keys(otaData[userId]['category'])[0];
      let catMapArr = firstCategoryWithMapping.split('_');
      let firstCategory = catMapArr[0];
      
      if (typeof inventoryData.categoryrateplanmapping[firstCategoryWithMapping] !== 'undefined' &&
          Object.keys(inventoryData.categoryrateplanmapping[firstCategoryWithMapping]['ratePlans']).length > 0) {
        let firstRatePlanId = Object.keys(
          inventoryData.categoryrateplanmapping[firstCategoryWithMapping]['ratePlans']
        )[0];
        otaData[userId]['category'][firstCategoryWithMapping]['rateplans'] = inventoryData.categoryrateplanmapping[firstCategoryWithMapping]['ratePlans'];
        
        otaData = pushRateinOtaData(
          inventoryData.rateinventorylist,
          otaData,
          userId,
          firstCategoryWithMapping,
          firstRatePlanId
        );
        
        if (typeof others.rateplanSectionExpand[firstCategoryWithMapping] === 'undefined') {
          others.rateplanSectionExpand[firstCategoryWithMapping] = {};
        }
        others.rateplanSectionExpand[firstCategoryWithMapping][firstRatePlanId] = firstRatePlanId;
        
        if (Object.keys(otaData[userId]['category']).length > 0) {
          others['categorySectionExpand'][firstCategory] = firstCategory;
        }
      }
    }
  }

  response['others'] = others;
  response['otaData'] = otaData;
  callBack(response);
}

export function openPopupSectionUIHandler(popupIdentifier, commonData, others, callBack) {
  let response = {};
  response['popupUiDesign'] = others['popupUiDesign'];
  response['ratepopupUiDesign'] = others['ratepopupUiDesign'];
  if (
    popupIdentifier.trim() === 'block' ||
    popupIdentifier.trim() === 'unblock' ||
    popupIdentifier.trim() === 'inventory'
  ) {
    if (commonData.InventoryEventHandlingData.length > 0) {
      let result = inventoryDataPrepateForPopup(popupIdentifier, commonData, others);
      response['popupUiDesign'] = result['popupUiDesign'];
    }
  } else if (popupIdentifier.trim() === 'updaterate') {
    if (commonData.eventHandlingData.length > 0) {
      let result = ratedataPrepateForPopup(commonData['eventHandlingData']);
      response['ratepopupUiDesign'] = result['ratepopupUiDesign'];
    } else {
      alert('Please select rate');
    }
  } else if (popupIdentifier.trim() === 'stopsale' || popupIdentifier.trim() === 'startsale') {
    if (popupIdentifier.trim() === 'startsale') {
      if (commonData.startStopSaleEventHandlingData.length > 0) {
        let result = inventoryDataPrepateForPopup(popupIdentifier, commonData, others);
        response['popupUiDesign'] = result['popupUiDesign'];
        // $scope.inventoryDataPrepateForPopup('startsale');
        //     $scope.others.popupIdentifier = popupIdentifier;
      } else {
        // cf.notifyError($filter("translate")("NO_STARTSALE_DATA"));
      }
    }
    if (popupIdentifier.trim() === 'stopsale') {
      if (commonData.InventoryEventHandlingData.length > 0) {
        let result = inventoryDataPrepateForPopup(popupIdentifier, commonData, others);
        response['popupUiDesign'] = result['popupUiDesign'];
        //$scope.others.popupIdentifier = popupIdentifier;
      } else {
        // cf.notifyError($filter("translate")("NO_STARTSALE_DATA"));
      }
    }
  } else if (popupIdentifier.trim() === 'allocation') {
    /* if ($scope.InventoryEventHandlingData.length > 0 || $scope.startStopSaleEventHandlingData.length > 0) {
      $scope.inventoryDataPrepateForPopup(popupIdentifier);
      $scope.others.popupIdentifier = popupIdentifier;
    } else {
      cf.notifyError($filter("translate")("NO_STARTSALE_DATA"));
    }*/
  }

  response['popupIdentifier'] = popupIdentifier;
  callBack(response);
  // /return response;
}

export function ratedataPrepateForPopup(eventHandlingData) {
  let response = {};
  var nextDate = {};
  var currentDate = '';
  let ratepopupUiDesign = {};
  var uiPrepareDataSort = sortByDate(eventHandlingData);
  var i = 0;
  for (var j = 0; j < uiPrepareDataSort.length; j++) {
    let data = uiPrepareDataSort[j];
    if (typeof ratepopupUiDesign[data['category_id']] === 'undefined') {
      ratepopupUiDesign[data['category_id']] = {};
    }
    if (typeof ratepopupUiDesign[data['category_id']][data['occupancy_id']] === 'undefined') {
      ratepopupUiDesign[data['category_id']][data['occupancy_id']] = {};
    }
    if (typeof nextDate[data['category_id']] === 'undefined') {
      nextDate[data['category_id']] = '';
    }
    currentDate = new Date(data['date']);
    if (currentDate > nextDate[data['category_id']]) {
      i++;
      if (typeof ratepopupUiDesign[data['category_id']][data['occupancy_id']][i] === 'undefined') {
        ratepopupUiDesign[data['category_id']][data['occupancy_id']][i] = {};
      }
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date'] = data['date'];
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date_display'] = formatDate(
        data['date'],
        'yyyy-mm-dd',
        dateFormate
      );
    }
    if (typeof ratepopupUiDesign[data['category_id']][data['occupancy_id']][i] === 'undefined') {
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i] = {};
    }
    if (typeof ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date'] === 'undefined') {
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date'] = data['date'];
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date_display'] = formatDate(
        data['date'],
        'yyyy-mm-dd',
        dateFormate
      );
    }
    nextDate[data['category_id']] = new Date(data['date']);
    nextDate[data['category_id']].setDate(nextDate[data['category_id']].getDate() + 1);
    ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['category_id'] = data['category_id'];
    if (
      typeof ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] !== 'undefined' &&
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] < data['date']
    ) {
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] = data['date'];
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date_display'] = formatDate(
        data['date'],
        'yyyy-mm-dd',
        dateFormate
      );
    } else if (typeof ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] === 'undefined') {
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] = data['date'];
      ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date_display'] = formatDate(
        data['date'],
        'yyyy-mm-dd',
        dateFormate
      );
    }
    ratepopupUiDesign[data['category_id']][data['occupancy_id']][i]['rate_plan_id'] = data['rate_plan_id'];
  }
  response['ratepopupUiDesign'] = ratepopupUiDesign;
  return response;
}

export function inventoryDataPrepateForPopup(inventoryStartStopSaleIdentifier, commonData, others) {
  let response = {};
  let startStopSaleEventHandlingData = commonData['startStopSaleEventHandlingData'];
  let InventoryEventHandlingData = commonData['InventoryEventHandlingData'];
  let popupUiDesign = others['popupUiDesign'];
  var nextDate = {};
  var currentDate = '';
  var i = 0;
  //$scope.others.popupUiDesign = {};
  let uiPrepareDataSort = [];
  uiPrepareDataSort = sortByDate(InventoryEventHandlingData);
  if (inventoryStartStopSaleIdentifier === 'startsale') {
    uiPrepareDataSort = [];
    uiPrepareDataSort = sortByDate(startStopSaleEventHandlingData);
    //uiPrepareDataSort= angular.copy($filter('orderBy')($scope.startStopSaleEventHandlingData, 'date'));
  } else if (inventoryStartStopSaleIdentifier === 'allocation') {
    /*   var dataNeedToPush =  uiPrepareDataSort;
    angular.forEach($scope.startStopSaleEventHandlingData, function (popupData, index) {
       dataNeedToPush.push(popupData);
      });
      uiPrepareDataSort = [];
      uiPrepareDataSort = angular.copy($filter('orderBy')(dataNeedToPush, 'date'));*/
  }

  for (var d = 0; d < uiPrepareDataSort.length; d++) {
    let popupData = uiPrepareDataSort[d];
    // angular.forEach(uiPrepareDataSort, function (popupData, index) {
    var data = { ...popupData };
    var date = data['date'];
    data['date'] = formatDate(data['date'], 'yyyy-mm-dd', dateFormate);
    if (typeof popupUiDesign === 'undefined') {
      popupUiDesign = {};
    }
    if (typeof popupUiDesign[data['category_id']] === 'undefined') {
      popupUiDesign[data['category_id']] = {};
    }

    currentDate = new Date(formatDate(date, 'yyyy-mm-dd', dateFormate));
    if (currentDate > nextDate[data['category_id']]) {
      i++;
      if (typeof popupUiDesign[data['category_id']][data['occupancy_id']][i] === 'undefined') {
        popupUiDesign[data['category_id']][data['occupancy_id']][i] = {};
      }
      popupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date'] = data['date'];
      popupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date_display'] = formatDate(
        data['date'],
        'yyyy-mm-dd',
        dateFormate
      );
    }
    if (typeof popupUiDesign[data['category_id']][data['occupancy_id']][i] === 'undefined') {
      popupUiDesign[data['category_id']][data['occupancy_id']][i] = {};
    }
    if (typeof popupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date'] === 'undefined') {
      popupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date'] = data['date'];
      popupUiDesign[data['category_id']][data['occupancy_id']][i]['start_date_display'] = formatDate(
        data['date'],
        'yyyy-mm-dd',
        dateFormate
      );
    }
    nextDate[data['category_id']] = new Date(data['date']);
    nextDate[data['category_id']].setDate(nextDate[data['category_id']].getDate() + 1);
    popupUiDesign[data['category_id']][data['occupancy_id']][i]['category_id'] = data['category_id'];
    if (
      typeof popupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] !== 'undefined' &&
      popupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] < data['date']
    ) {
      popupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] = data['date'];
      popupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date_display'] = formatDate(
        data['date'],
        'yyyy-mm-dd',
        dateFormate
      );
    } else if (typeof popupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] === 'undefined') {
      popupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date'] = data['date'];
      popupUiDesign[data['category_id']][data['occupancy_id']][i]['end_date_display'] = formatDate(
        data['date'],
        'yyyy-mm-dd',
        dateFormate
      );
    }
    popupUiDesign[data['category_id']][data['occupancy_id']][i]['rate_plan_id'] = data['rate_plan_id'];
  }
  response['popupUiDesign'] = popupUiDesign;
  return response;
}

export function sortByDate(InventoryEventHandlingData) {
  // let response = [];
  for (var i = 0; i < InventoryEventHandlingData.length; i++) {
    for (var j = i + 1; j < InventoryEventHandlingData.length; j++) {
      if (
        new Date(InventoryEventHandlingData[i]['date']).getTime() >
        new Date(InventoryEventHandlingData[j]['date']).getTime()
      ) {
        var temp = InventoryEventHandlingData[i];
        InventoryEventHandlingData[i] = InventoryEventHandlingData[j];
        InventoryEventHandlingData[j] = temp;
      }
    }
  }
  return InventoryEventHandlingData;
}

export function closePopupUIHandler(identifier, commonData, others, callBack) {
  let response = {};
  response['popupIdentifier'] = '';
  if (identifier === 'stopsale') {
    // let result = inventoryDataPrepateForPopup('stopsale', commonData, others);
  } else if (identifier === 'updaterate') {
    // $scope.others.selectedDays = Object.keys($scope.others.weekDaysList);
    //$scope.resetRateUpdatePopup();
  } else if (identifier === 'unblock_block') {
    // $scope.resetRateUpdatePopup();
  }
  callBack(response);
}

export function selectCellEventHandler(params, others, commonData, dateList, callBack) {
  let response = {};
  let rateinventorySelectedSection = others['rateinventorySelectedSection'];
  let horizontalRowChecked = others['horizontalRowChecked'];
  let eventHandlingData = commonData['eventHandlingData'];
  let showHideButton = others['showHideButton'];
  let ischecked = '';
  if (typeof params.ischecked !== 'undefined') {
    ischecked = params.ischecked;
  }
  rateinventorySelectedSection = defineRateinventorySelectedSection(
    rateinventorySelectedSection,
    params.ratePlanId,
    params.userId,
    params.categoryId,
    params.datekey,
    params.occupancyId
  );

  if (
    isDeselectCell(horizontalRowChecked, params.categoryId, params.ratePlanId, params.occupancyId, ischecked) &&
    typeof rateinventorySelectedSection[params.ratePlanId][params.userId][params.categoryId][params.datekey][
      params.occupancyId
    ]['isSelected'] !== 'undefined' &&
    rateinventorySelectedSection[params.ratePlanId][params.userId][params.categoryId][params.datekey][
      params.occupancyId
    ]['isSelected'] === 1
  ) {
    rateinventorySelectedSection[params.ratePlanId][params.userId][params.categoryId][params.datekey][
      params.occupancyId
    ]['isSelected'] = 0;
    eventHandlingData = deleteRateinventorySelectedSection(
      eventHandlingData,
      params.ratePlanId,
      params.userId,
      params.categoryId,
      params.datekey,
      params.occupancyId
    );
  } else {
    let result = pushDataToEventHandlingData(
      rateinventorySelectedSection,
      eventHandlingData,
      params.ratePlanId,
      params.userId,
      params.categoryId,
      params.datekey,
      params.occupancyId
    );

    eventHandlingData = result['eventHandlingData'];
    rateinventorySelectedSection = result['rateinventorySelectedSection'];
  }
  if (typeof ischecked === 'undefined' || ischecked !== 'ischecked') {
    horizontalRowChecked = isHorizontalRateSection(
      dateList,
      rateinventorySelectedSection,
      horizontalRowChecked,
      params.userId,
      params.categoryId,
      params.ratePlanId,
      params.occupancyId
    );
  }
  response['selectedCategory'] = params.categoryId;
  showHideButton = enableAndDisableButtons(params.userId, params.categoryId, params.datekey, commonData, others);

  response['rateinventorySelectedSection'] = rateinventorySelectedSection;
  response['eventHandlingData'] = eventHandlingData;
  response['showHideButton'] = showHideButton;
  response['horizontalRowChecked'] = horizontalRowChecked;

  callBack(response);
}

export function pushDataToEventHandlingData(
  rateinventorySelectedSection,
  eventHandlingData,
  ratePlanId,
  userId,
  categoryId,
  datekey,
  occupancyId
) {
  let response = {};
  rateinventorySelectedSection[ratePlanId][userId][categoryId][datekey][occupancyId]['isSelected'] = 1;
  eventHandlingData.push({
    date: datekey,
    category_id: categoryId,
    occupancy_id: occupancyId,
    rate_plan_id: ratePlanId,
    user_id: userId,
    aop: 0
  });
  response['rateinventorySelectedSection'] = rateinventorySelectedSection;
  response['eventHandlingData'] = eventHandlingData;
  return response;
}

export function deleteRateinventorySelectedSection(eventHandlingData, ratePlanId, userId, categoryId, datekey, occupancyId) {
  var index = findIndexifValueExist(eventHandlingData, ratePlanId, userId, categoryId, datekey, occupancyId);
  eventHandlingData.splice(index, 1);
  return eventHandlingData;
}

export function findIndexifValueExist(eventHandlingData, ratePlanId, userId, categoryId, datekey, occupancyId) {
  var findMe = {
    date: datekey,
    category_id: categoryId,
    occupancy_id: occupancyId,
    rate_plan_id: ratePlanId,
    user_id: userId
  };
  var index = eventHandlingData.findIndex(row => {
    if (
      row.date === findMe.date &&
      parseInt(row.category_id) === parseInt(findMe.category_id) &&
      parseInt(row.occupancy_id) === parseInt(findMe.occupancy_id) &&
      parseInt(row.rate_plan_id) === parseInt(findMe.rate_plan_id) &&
      parseInt(row.user_id) === parseInt(findMe.user_id)
    ) {
      return true;
    } else {
      return false;
    }
  });
  return index;
}

export function isDeselectCell(horizontalRowChecked, categoryId, ratePlanId, occupancyId, ischecked) {
  if (typeof horizontalRowChecked[categoryId] !== 'undefined') {
    if (typeof horizontalRowChecked[categoryId][ratePlanId] !== 'undefined') {
      if (typeof horizontalRowChecked[categoryId][ratePlanId][occupancyId] !== 'undefined') {
        if (
          typeof ischecked !== 'undefined' &&
          ischecked === 'ischecked' &&
          typeof horizontalRowChecked[categoryId][ratePlanId][occupancyId]['is_checked'] !== 'undefined' &&
          horizontalRowChecked[categoryId][ratePlanId][occupancyId]['is_checked'] === 1
        ) {
          return false;
        }
      }
    }
  }
  return true;
}

export function defineRateinventorySelectedSection(
  rateinventorySelectedSection,
  ratePlanId,
  userId,
  categoryId,
  datekey,
  occupancyId
) {
  if (typeof rateinventorySelectedSection[ratePlanId] === 'undefined') {
    rateinventorySelectedSection[ratePlanId] = {};
  }
  if (typeof rateinventorySelectedSection[ratePlanId][userId] === 'undefined') {
    rateinventorySelectedSection[ratePlanId][userId] = {};
  }
  if (typeof rateinventorySelectedSection[ratePlanId][userId][categoryId] === 'undefined') {
    rateinventorySelectedSection[ratePlanId][userId][categoryId] = {};
  }
  if (typeof rateinventorySelectedSection[ratePlanId][userId][categoryId][datekey] === 'undefined') {
    rateinventorySelectedSection[ratePlanId][userId][categoryId][datekey] = {};
  }
  if (typeof rateinventorySelectedSection[ratePlanId][userId][categoryId][datekey][occupancyId] === 'undefined') {
    rateinventorySelectedSection[ratePlanId][userId][categoryId][datekey][occupancyId] = {};
  }
  return rateinventorySelectedSection;
}

export function isHorizontalRateSection(
  dateList,
  rateinventorySelectedSection,
  horizontalRowChecked,
  userId,
  categoryId,
  rateplanId,
  occupancyId
) {
  var flag = 1;
  let dates = Object.keys(dateList);
  for (var i = 0; i < dates.length; i++) {
    if (typeof rateinventorySelectedSection[rateplanId] === 'undefined') {
      flag = 0;
    } else if (typeof rateinventorySelectedSection[rateplanId][userId] === 'undefined') {
      flag = 0;
    } else if (typeof rateinventorySelectedSection[rateplanId][userId][categoryId] === 'undefined') {
      flag = 0;
    } else if (typeof rateinventorySelectedSection[rateplanId][userId][categoryId][dates[i]] === 'undefined') {
      flag = 0;
    } else if (
      typeof rateinventorySelectedSection[rateplanId][userId][categoryId][dates[i]][occupancyId] === 'undefined'
    ) {
      flag = 0;
    } else if (
      rateinventorySelectedSection[rateplanId][userId][categoryId][dates[i]][occupancyId]['isSelected'] === 0
    ) {
      flag = 0;
    }
  }
  if (flag === 1) {
    if (typeof horizontalRowChecked[categoryId] === 'undefined') {
      horizontalRowChecked[categoryId] = {};
    }
    if (typeof horizontalRowChecked[categoryId][rateplanId] === 'undefined') {
      horizontalRowChecked[categoryId][rateplanId] = {};
    }
    if (typeof horizontalRowChecked[categoryId][rateplanId][occupancyId] === 'undefined') {
      horizontalRowChecked[categoryId][rateplanId][occupancyId] = {};
    }
    if (typeof horizontalRowChecked[categoryId][[rateplanId]] === 'undefined') {
      horizontalRowChecked[categoryId][rateplanId][occupancyId] = {};
    }
    horizontalRowChecked[categoryId][rateplanId][occupancyId]['is_checked'] = 1;
  } else {
    if (typeof horizontalRowChecked[categoryId] !== 'undefined') {
      if (typeof horizontalRowChecked[categoryId][rateplanId] !== 'undefined') {
        if (typeof horizontalRowChecked[categoryId][rateplanId][occupancyId] !== 'undefined') {
          horizontalRowChecked[categoryId][rateplanId][occupancyId]['is_checked'] = 0;
        }
      }
    }
  }
  return horizontalRowChecked;
}

export function getOccupancyDetails(data, occupancy) {
  let result = 0;
  for (var key = 0; key < data.length; key++) {
    if (data[key].occupancy.includes(occupancy)) {
      result = key;
    }
  }
  return result;
}

export function prepareDataForRateUpdate(commonData, callBack) {
  let response = {};
  let rateUpdateData = JSON.parse(JSON.stringify(commonData.rateUpdateData)); // Object.assign({}, commonData.rateUpdateData);
  let eventHandlingData = commonData.eventHandlingData;
  let uiPrepareDataSort = sortByDate(eventHandlingData);
  let uiPrepareDataSortKeys = Object.keys(uiPrepareDataSort);
  let dateDictionary = {};
  for (var key = 0; key < uiPrepareDataSortKeys.length; key++) {
    let data = uiPrepareDataSort[uiPrepareDataSortKeys[key]];
    if (typeof dateDictionary[data['rate_plan_id']] === 'undefined') {
      dateDictionary[data['rate_plan_id']] = {};
    }
    if (typeof dateDictionary[data['rate_plan_id']][data['category_id']] === 'undefined') {
      dateDictionary[data['rate_plan_id']][data['category_id']] = {};
    }
    if (typeof dateDictionary[data['rate_plan_id']][data['category_id']][data['date']] === 'undefined') {
      dateDictionary[data['rate_plan_id']][data['category_id']][data['date']] = {};
    }
    if (typeof dateDictionary[data['rate_plan_id']][data['category_id']][data['date']]['occupancy'] === 'undefined') {
      dateDictionary[data['rate_plan_id']][data['category_id']][data['date']]['occupancy'] = [];
    }
    if (
      dateDictionary[data['rate_plan_id']][data['category_id']][data['date']]['occupancy'].indexOf(
        data['occupancy_id']
      ) === -1
    ) {
      dateDictionary[data['rate_plan_id']][data['category_id']][data['date']]['occupancy'].push(data['occupancy_id']);
    }
  }
  //rateUpdateData

  var index = 0;
  var ratePlanIds = Object.keys(dateDictionary);
  for (var r = 0; r < ratePlanIds.length; r++) {
    var ratePlanId = ratePlanIds[r];
    var categoryData = dateDictionary[ratePlanId];
    var categoryIds = Object.keys(categoryData);
    for (var c = 0; c < categoryIds.length; c++) {
      var categoryId = categoryIds[c];
      var dateData = categoryData[categoryId];
      var dateKeys = Object.keys(dateData);
      for (var d = 0; d < dateKeys.length; d++) {
        var date = dateKeys[d];
        var occupancy = dateData[date]['occupancy'];
        if (typeof rateUpdateData[ratePlanId] === 'undefined') {
          rateUpdateData[ratePlanId] = {};
        }
        if (typeof rateUpdateData[ratePlanId][categoryId] === 'undefined') {
          rateUpdateData[ratePlanId][categoryId] = {};
        }
        if (typeof rateUpdateData[ratePlanId][categoryId][index] === 'undefined') {
          rateUpdateData[ratePlanId][categoryId][index] = {};
        }
        rateUpdateData[ratePlanId][categoryId][index]['category_id'] = categoryId;
        rateUpdateData[ratePlanId][categoryId][index]['rate_plan_id'] = ratePlanId;
        rateUpdateData[ratePlanId][categoryId][index]['start_date'] = date;
        rateUpdateData[ratePlanId][categoryId][index]['end_date'] = date;
        rateUpdateData[ratePlanId][categoryId][index]['occupancy'] = occupancy;
        index++;
      }
    }
  }

  response['rateUpdateData'] = rateUpdateData;

  callBack(response);
}

export function prepareDataForRateUpdateOld(commonData, callBack) {
  let response = {};
  var nextDate = {};
  var currentDate = '';
  var i = 0;
  // var j = 0;
  //let rateUpdateData=commonData.rateUpdateData;
  let rateUpdateData = JSON.parse(JSON.stringify(commonData.rateUpdateData)); // Object.assign({}, commonData.rateUpdateData);
  let eventHandlingData = commonData.eventHandlingData;
  let uiPrepareDataSort = sortByDate(eventHandlingData);
  let uiPrepareDataSortKeys = Object.keys(uiPrepareDataSort);
  for (var key = 0; key < uiPrepareDataSortKeys.length; key++) {
    let data = uiPrepareDataSort[uiPrepareDataSortKeys[key]];
    if (typeof rateUpdateData[data['rate_plan_id']] === 'undefined') {
      rateUpdateData[data['rate_plan_id']] = {};
    }
    if (typeof rateUpdateData[data['rate_plan_id']][data['category_id']] === 'undefined') {
      rateUpdateData[data['rate_plan_id']][data['category_id']] = {};
    }
    if (typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i] === 'undefined') {
      rateUpdateData[data['rate_plan_id']][data['category_id']][i] = {};
    }
    if (typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i]['occupancy'] === 'undefined') {
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]['occupancy'] = [];
    }
    if (typeof nextDate[data['category_id']] === 'undefined') {
      nextDate[data['category_id']] = '';
    }
    currentDate = new Date(data['date']);
    if (currentDate > nextDate[data['category_id']]) {
      // j++;
      i++;
      if (typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i] === 'undefined') {
        rateUpdateData[data['rate_plan_id']][data['category_id']][i] = {};
      }
      if (typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i]['occupancy'] === 'undefined') {
        rateUpdateData[data['rate_plan_id']][data['category_id']][i]['occupancy'] = [];
      }
      //if(typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i]['start_date']=='undefined'){
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]['start_date'] = data['date'];
      //}
    }
    if (typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i] === 'undefined') {
      rateUpdateData[data['rate_plan_id']][data['category_id']][i] = {};
    }

    if (typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i]['start_date'] === 'undefined') {
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]['start_date'] = data['date'];
    }
    // i = j;
    /*var index= findIndextoPush(data['category_id'],data['occupancy_id'],rateUpdateData[data['rate_plan_id']][data['category_id']]);
      if(index > -1){
        i=index;
      }*/

    nextDate[data['category_id']] = new Date(data['date']);
    nextDate[data['category_id']].setDate(nextDate[data['category_id']].getDate() + 1);
    //nextDate[data['category_id']]=nextDate[data['category_id']];
    /*if(typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i]=='undefined'){
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]={};
    }
    if(typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i]['occupancy']=='undefined'){
       rateUpdateData[data['rate_plan_id']][data['category_id']][i]['occupancy']=[];
    }
    if(typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i]['start_date']=='undefined'){
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]['start_date']=data['date'];
    }*/
    rateUpdateData[data['rate_plan_id']][data['category_id']][i]['category_id'] = data['category_id'];
    if (
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]['occupancy'].indexOf(data['occupancy_id']) === -1
    ) {
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]['occupancy'].push(data['occupancy_id']);
    }
    if (
      typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i]['end_date'] !== 'undefined' &&
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]['end_date'] < data['date']
    ) {
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]['end_date'] = data['date'];
    } else if (typeof rateUpdateData[data['rate_plan_id']][data['category_id']][i]['end_date'] === 'undefined') {
      rateUpdateData[data['rate_plan_id']][data['category_id']][i]['end_date'] = data['date'];
    }
  }
  response['rateUpdateData'] = rateUpdateData;
  callBack(response);
}

export function findIndextoPush(categoryId, occupancyId, requestData) {
    // var findMe = { categoryId: categoryId, occupancyId: occupancyId };
    var findIndex = -1;
    /*for(var i=0;i<requestData.length;i++){
      if (findIndex < 0 && row.occupancy.indexOf(occupancyId)>-1 && row.category_id === findMe.categoryId) {
        findIndex =index;
       }
    }*/
    return findIndex;
  }
export function defineHorizontalRowInventorySelection(horizontalInventoryRowChecked, userId, categoryId) {
  if (typeof horizontalInventoryRowChecked[userId] === 'undefined') {
    horizontalInventoryRowChecked[userId] = {};
  }
  if (typeof horizontalInventoryRowChecked[userId][categoryId] === 'undefined') {
    horizontalInventoryRowChecked[userId][categoryId] = {};
  }
  if (
    typeof horizontalInventoryRowChecked[userId][categoryId]['is_checked'] !== 'undefined' &&
    horizontalInventoryRowChecked[userId][categoryId]['is_checked'] === 1
  ) {
    horizontalInventoryRowChecked[userId][categoryId]['is_checked'] = 0;
  } else {
    horizontalInventoryRowChecked[userId][categoryId]['is_checked'] = 1;
  }
  return horizontalInventoryRowChecked;
}
export function getStartStopSaleIdentifier(otaData, userId, categoryId, dateKey) {
  var identifier = 'stopsale';
  if (typeof otaData[userId]['category'][categoryId] !== 'undefined') {
    if (typeof otaData[userId]['category'][categoryId]['inventory'] !== 'undefined') {
      if (typeof otaData[userId]['category'][categoryId]['inventory'][dateKey] !== 'undefined') {
        if (otaData[userId]['category'][categoryId]['inventory'][dateKey]['stopSell'] === 1) {
          identifier = 'startsale';
        }
      }
    }
  }
  return identifier;
}
 export function horizontalInventoryUIHandler(dateList, others, commonData, categoryWithMapping, userId, backup, callBack) {
    let result = {};
    let catMappingArr = categoryWithMapping.split('_');
    let categoryId = catMappingArr[0];
    others['horizontalInventoryRowChecked'] = defineHorizontalRowInventorySelection(
      others['horizontalInventoryRowChecked'],
      userId,
      categoryWithMapping
    );
    var dateListKeys = Object.keys(dateList);
    for (var i = 0; i < dateListKeys.length; i++) {
      var date = dateListKeys[i];
      var identifier = getStartStopSaleIdentifier(commonData.otaData, userId, categoryWithMapping, date);
      inventoryCellUIHandler(
        others,
        userId,
        categoryId,
        date,
        identifier,
        'ischecked',
        commonData,
        dateList,
        backup,
        categoryWithMapping,
        response => {
          result = response;
        }
      );
    }
    callBack(result);
}
 
  export function horizontalRowSelection(userId, rateplanId, categoryId, occupancyId, others, commonData, dateList, callBack) {
    let reponse = {};
    let horizontalRowChecked = others.horizontalRowChecked;
    if (userId > 0) {
      alert('You can not update OTA rate or inventories');
      return false;
    }
    horizontalRowChecked = defineHorizontalRowSelection(categoryId, rateplanId, occupancyId, horizontalRowChecked);
    horizontalRowChecked = horizontalRowCheckUncheck(categoryId, rateplanId, occupancyId, horizontalRowChecked);
    others['horizontalRowChecked'] = horizontalRowChecked['horizontalRowChecked'];
    others['selectedCategory'] = horizontalRowChecked['selectedCategory'];
    var dateListKeys = Object.keys(dateList);
    let params = {};
    for (var i = 0; i < dateListKeys.length; i++) {
      var datekey = dateListKeys[i];
      params['categoryId'] = categoryId;
      params['occupancyId'] = occupancyId;
      params['ratePlanId'] = rateplanId;
      params['userId'] = userId;
      params['ischecked'] = 'ischecked';
      params['datekey'] = datekey;
      selectCellEventHandler(params, others, commonData, dateList, result => {
        reponse = result;
      });
    }
    callBack(reponse);
  }

  export function horizontalRowCheckUncheck(categoryId, rateplanId, occupancyId, horizontalRowChecked) {
    var response = {};
    if (
      typeof horizontalRowChecked[categoryId][rateplanId][occupancyId]['is_checked'] !== 'undefined' &&
      horizontalRowChecked[categoryId][rateplanId][occupancyId]['is_checked'] === 1
    ) {
      horizontalRowChecked[categoryId][rateplanId][occupancyId]['is_checked'] = 0;
      response['selectedCategory'] = 0;
    } else {
      horizontalRowChecked[categoryId][rateplanId][occupancyId]['is_checked'] = 1;
    }
    response['horizontalRowChecked'] = horizontalRowChecked;
    return response;
  }

  export function defineHorizontalRowSelection(categoryId, rateplanId, occupancyId, horizontalRowChecked) {
    if (typeof horizontalRowChecked[categoryId] === 'undefined') {
      horizontalRowChecked[categoryId] = {};
    }
    if (typeof horizontalRowChecked[categoryId][rateplanId] === 'undefined') {
      horizontalRowChecked[categoryId][rateplanId] = {};
    }
    if (typeof horizontalRowChecked[categoryId][rateplanId][occupancyId] === 'undefined') {
      horizontalRowChecked[categoryId][rateplanId][occupancyId] = {};
    }
    return horizontalRowChecked;
  }

  export function findDateDiff(firstDateObject, secondDateObject) {
    try {
      var timeDiff = Math.abs(secondDateObject.getTime() - firstDateObject.getTime());
      var dateDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return dateDiff;
    } catch (error) {
      console.log(error);
    }
  }
  export function filterStopSaleData(
    commonData,
    others,
    backup,
    categoryId,
    index,
    identifier,
    userId,
    category_with_mapping,
    callBack
  ) {
    let result = {};
    commonData = filterByCategory(commonData, categoryId, identifier);
    let popupUiDesign = others.popupUiDesign;
    for (var i = 0; i < Object.keys(popupUiDesign[categoryId]).length; i++) {
      var dayData = popupUiDesign[categoryId][i];
      var firstDateObject = new Date(formatDate(dayData['start_date'], dateFormate, 'yyyy-mm-dd'));
      var secondDateObject = new Date(formatDate(dayData['end_date'], dateFormate, 'yyyy-mm-dd'));

      var dateDiff = findDateDiff(firstDateObject, secondDateObject);
      // var room_category_id = backup['categorymaster'][categoryId]['room_category_id'];
      for (var j = 0; j <= dateDiff; j++) {
        if (j > 0) {
          firstDateObject.setDate(firstDateObject.getDate() + 1);
        }
        var dateYMD = currentDateHandle(firstDateObject);
        // var dateYMDFromated = formatDate(dateYMD, dateFormate, 'yyyy-mm-dd');
        others.inventorySelectedSection = defineInventorySelectedSection(
          others.inventorySelectedSection,
          userId,
          categoryId,
          dateYMD
        );
        let response = prepareInventoryUIAndEventData(
          others.inventorySelectedSection,
          userId,
          category_with_mapping,
          dateYMD,
          identifier,
          commonData,
          backup
        );
        others['inventorySelectedSection'] = response['inventorySelectedSection'];
        commonData['InventoryEventHandlingData'] = response['InventoryEventHandlingData'];
        commonData['startStopSaleEventHandlingData'] = response['startStopSaleEventHandlingData'];
      }
    }
    result['commonData'] = commonData;
    result['others'] = others;
    callBack(result);
  }
  export function filterByCategory(commonData, categoryId, identifier) {
    var isFindIndex = 1;
    while (isFindIndex >= 0) {
      if (identifier === 'stopsale') {
        isFindIndex = commonData.InventoryEventHandlingData.findIndex(row => {
          if (row.category_id === categoryId) {
            return true;
          } else {
            return false;
          }
        });
        if (isFindIndex >= 0) {
          commonData.InventoryEventHandlingData.splice(isFindIndex, 1);
        }
      } else {
        isFindIndex = commonData.startStopSaleEventHandlingData.findIndex(row => {
          if (row.category_id === categoryId) {
            return true;
          } else {
            return false;
          }
        });
        if (isFindIndex >= 0) {
          commonData.startStopSaleEventHandlingData.splice(isFindIndex, 1);
        }
      }
    }
    return commonData;
  }